import { render } from "./ContactInfo.vue?vue&type=template&id=dcb963c0&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=dcb963c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dcb963c0"

export default script